import { generatePath } from 'react-router-dom'
import { ARCHIVE_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Trash2, Trash4 } from 'blaze-ui/icons'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuArchiveItem = ({ workspaceId, onPress }: Props) => (
  <NavMenuItem
    icon={Trash2}
    activeIcon={Trash4}
    to={generatePath(ARCHIVE_PATH, { workspaceId })}
    onPress={onPress}
    label="Archived Posts"
  />
)

export { NavMenuArchiveItem }
